import { Entity, EntityMap } from '../types';

export enum DismissablePromptKey {
  AnswersFAQifyOnboardingFRE = 'AnswersFAQifyOnboardingFRE',
  FirstRunAnalyticsBubble = 'FirstRunAnalyticsBubble',
  FirstRunExperience = 'FirstRunExperience',
  FirstRunExperienceStoryline = 'FirstRunExperienceStoryline',
  FirstRunExperienceStorylineInVivaEngage = 'FirstRunExperienceStorylineInVivaEngage',
  InclusiveReactions = 'InclusiveReactions',
  LeadersDirectoryConnectedLeaders = 'LeadersDirectoryConnectedLeaders',
  LeadersDirectoryFollowedLeaders = 'LeadersDirectoryFollowedLeaders',
  LeadersDirectoryAllLeaders = 'LeadersDirectoryAllLeaders',
  LeadershipCornerBanner = 'LeadershipCornerBanner',
  LightboxFollowUsers = 'LightboxFollowUsers',
  LightboxJoinGroups = 'LightboxJoinGroups',
  LockedAchievementsFRE = 'LockedAchievementsFRE',
  MobileCrossSellQRCode = 'MobileCrossSellQRCode',
  MobileCrossSellThreadViewBannerAd = 'MobileCrossSellThreadViewBanner',
  MobileCrossSellThreadViewCoachingBar = 'MobileCrossSellThreadViewCoachingBar',
  MobileUpsell = 'MobileUpsell',
  NetworkQuestionsUpvoteBubble = 'NetworkQuestionsUpvoteBubble',
  OutlookEngageRebrandingBanner = 'OutlookEngageRebrandingBanner',
  OutlookAnswersDigestBanner = 'OutlookAnswersDigestBanner',
  PublisherSaveAsDraftPrompt = 'PublisherSaveAsDraftPrompt',
  PushNotifications = 'PushNotifications',
  PWAInstall = 'PWAInstall',
  StorylineDigestCoachingBar = 'StorylineDigestCoachingBar',
  StorylineAnnouncementTeachingBubble = 'StorylineAnnouncementTeachingBubble',
  VivaEngageAdminPremiumSetupBanner = 'VivaEngageAdminPremiumSetupBanner',
  VivaEngageFRE = 'VivaEngageFRE',
  VivaEngageAmaCreationPromotion = 'VivaEngageAmaCreationPromotion',
  VivaEngageInOutlookFRE = 'VivaEngageInOutlookFRE',
  VivaEngageRebrandingNonAdminBanner = 'VivaEngageRebrandingNonAdminBanner',
  VivaEngageRebrandingAdminBanner = 'VivaEngageRebrandingAdminBanner',
}

export interface DismissablePrompt extends Entity {
  readonly isDismissed: boolean;
}

export type DismissablePrompts = EntityMap<DismissablePrompt>;
